/** Copyright 2026 Midas Healthcare Solutions - All Rights Reserved **/
import { InjectionToken } from '@angular/core';

export const RECAPTCHA_SITE_KEY = new InjectionToken<string>('RECAPTCHA_SITE_KEY');